import type {LngLat} from '@yandex-delivery/blocks'
import {Grid, MapMarker} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {useCallback, useState} from 'react'

import bottomArrow from '../assets/bottomArrow.svg'
import {PointPlacemarkIcon} from '../point-placemark-icon/PointPlacemarkIcon'
import {classes} from './PointPlacemark.classes'
import type {Props} from './types'

export function PointPlacemark(props: Props) {
  const {type, children, onDragStart, onDragEnd, draggable, ...otherProps} = props
  const [isDragging, setDragging] = useState(false)

  const dragStartHandler = useCallback(
    (e: LngLat) => {
      setDragging(true)
      onDragStart?.(e)
    },
    [onDragStart],
  )

  const dragEndHandler = useCallback(
    (e: LngLat) => {
      setDragging(false)
      onDragEnd?.(e)
    },
    [onDragEnd],
  )

  return (
    <MapMarker {...otherProps} draggable={draggable} onDragEnd={dragEndHandler} onDragStart={dragStartHandler}>
      <div className={clsx(classes.container, draggable && classes.containerDraggable, isDragging && classes.dragging)}>
        <Grid alignItems="center" className={classes.paper} container>
          <div className={clsx(classes.placeMarkWrap, classes[`placeMarkWrap_${type}`])}>
            <PointPlacemarkIcon type={type}>{children}</PointPlacemarkIcon>
          </div>
        </Grid>
        {draggable ? (
          <div className={clsx(classes.stick, isDragging && classes.stickDragging)} />
        ) : (
          <React.Fragment>
            <img alt="bottomArrow" className={classes.arrow} src={bottomArrow} />
            <div className={classes.arrowPoint} />
          </React.Fragment>
        )}
      </div>
    </MapMarker>
  )
}
